import { Component, OnInit, Input } from '@angular/core';
import { Labels } from 'src/app/app.models';
import { Store } from '@ngrx/store';
import { defaultCountry } from 'src/app/store/service-options';

@Component({
    selector: 'app-walmart-footnote',
    templateUrl: './walmart-footnote.component.html',
    styleUrls: ['./walmart-footnote.component.scss'],
    standalone: false
})
export class WalmartFootnoteComponent implements OnInit {
  public country: string = '';

  private _labels: any;
  @Input() public set labels(labels: Labels) {
    this._labels = labels;
  }
  public get labels() {
    return this._labels;
  }

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.select(defaultCountry).subscribe((country) => {
      this.country = country;
    });
  }
}
